import { Offer } from 'typescript/types/api/offers';
import { toCurrency } from 'typescript/utilities/currency';
import t from 'typescript/utilities/translate';

export const isAnyOfferSelected = (offers: Offer[]): boolean => {
  return offers.some((offer) => offer.selected);
};

export const buildOptionFromOffer = ({
  offer,
  disabled,
}: {
  offer: Offer;
  disabled: boolean;
}) => {
  return {
    id: offer.token,
    title: t('checkout.payment_v3.payInInstallments.offers.months', {
      n: offer.number_payment_periods.toString(),
    }),
    subtext: [
      t('checkout.payment_v3.payInInstallments.offers.financingFee', {
        amount: toCurrency({
          amount: Number.parseFloat(offer.fee_amount.amount),
          currency: offer.fee_amount.currency_code,
        }),
      }),
    ],
    sideLabel: t('checkout.payment_v3.payInInstallments.offers.perMonth', {
      amount: toCurrency({
        amount: Number.parseFloat(offer.payment_amount.amount),
        currency: offer.payment_amount.currency_code,
      }),
    }),
    value: offer.token,
    selected: offer.selected,
    disabled,
  };
};
